import { render } from "./PdfOs.vue?vue&type=template&id=49f3a4b7&scoped=true"
import script from "./PdfOs.vue?vue&type=script&lang=js"
export * from "./PdfOs.vue?vue&type=script&lang=js"

import "./PdfOs.vue?vue&type=style&index=0&id=49f3a4b7&lang=scss&scoped=true"

import exportComponent from "/media/ctis/developer/WorkSpaceFront/cdas-intranet-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49f3a4b7"]])

export default __exports__